import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App.vue";
import Toasted from "vue-toasted";
import { authMiddleware } from "@/middleware/authMiddleware";
import i18n from "./i18n";

// AOS
import AOS from "aos";
import "aos/dist/aos.css";

// GSAP
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

Vue.config.productionTip = false;

// Register GSAP plugin
gsap.registerPlugin(ScrollTrigger);

// Use Vue plugins
Vue.use(VueRouter);
Vue.use(Toasted, {
  position: "top-center",
  duration: 2000,
});

// Initialize AOS
AOS.init({
  duration: 800,
  once: true,
  easing: "ease-in-out",
});

// Create router instance
const router = new VueRouter({
  mode: "history",
  routes: [
    { path: "/", component: () => import("./pages/Home.vue") },
    { path: "/contact", component: () => import("./pages/ContactPage.vue") },
    { path: "/legal", component: () => import("./pages/Legalinformation.vue") },
    { path: "/conseil", component: () => import("./pages/Conseil/Conseil.vue") },
    { path: "/Formation", component: () => import("./pages/Formation/Formation.vue") },
    { path: "/Recherche", component: () => import("./pages/Recherche/Recherche.vue") },
    { path: "/voyage", component: () => import("./pages/Liberte/Travel/travel.vue") },
    { path: "/sport", component: () => import("./pages/Liberte/Sport/sport.vue") },
    { path: "/creativity", component: () => import("./pages/Liberte/Creativity/creativity.vue") },
    { path: "/login", component: () => import("./pages/Admin/login.vue") },
    { path: "/histoire", component: () => import("./pages/Histoire/Histoire.vue") },

    {
      path: "/homeAdmin",
      component: () => import("./pages/Admin/home.vue"),
      beforeEnter: authMiddleware,
      redirect: "/homeAdmin/actualites",
      children: [
        { path: "actualites", component: () => import("./components/Admin/News/NewsAdminPanel.vue") },
        { path: "voyage", component: () => import("./components/Admin/Travel/TravelAdminPanel.vue") },
        { path: "creativite", component: () => import("./components/Admin/Creativity/CreativityAdminPanel.vue") },
        { path: "sport", component: () => import("./components/Admin/Sport/SportAdminPanel.vue") },
      ],
    },

    { path: "/setpassword", component: () => import("./pages/password/_token.vue") },
    { path: "/morenews", component: () => import("./pages/News/DisplayMoreNews.vue") },

    {
      path: "/moreReading/:id",
      name: "MoreReading",
      component: () => import("./pages/News/MoreReading.vue"),
      props: true,
    },

    {
      path: "/TravelDetails/:id",
      name: "TravelDetails",
      component: () => import("./pages/Liberte/Travel/travelDetails.vue"),
      props: true,
    },

    {
      path: "/SportDetails/:id",
      name: "SportDetails",
      component: () => import("./pages/Liberte/Sport/sportDetails.vue"),
      props: true,
    },

    {
      path: "/creativity/:id",
      name: "CreationDetails",
      component: () => import("./pages/Liberte/Creativity/creativityDetails.vue"),
      props: true,
    },
  ],

  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

// Mount the Vue app
new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");